import { aNumero, limpiarTexto, MONTO_MAXIMO } from './validacion';
import { esPorPeso, redondearCantidad, UNIDADES } from './unidades';

// Valida los datos de un producto. Devuelve un objeto { campo: mensaje }
// vacío si todo está bien. `esNuevo` exige categoría.
export function validarProducto(producto, { esNuevo = false } = {}) {
  const e = {};
  const nombre = (producto.nombre || '').trim();
  if (!nombre) e.nombre = 'El nombre es obligatorio';
  else if (nombre.length < 2) e.nombre = 'El nombre es muy corto';
  else if (nombre.length > 120) e.nombre = 'El nombre es muy largo (máximo 120 letras)';

  if (esNuevo && !producto.categoria) e.categoria = 'Selecciona una categoría';
  // La foto ya NO es obligatoria: se puede crear un producto sin foto
  // (ej. una venta rápida con la clienta esperando) y agregarla después.

  // --- Stock: sin letras, no negativo; entero salvo productos por peso ---
  if (producto.stock !== '' && producto.stock !== null && producto.stock !== undefined) {
    const stock = aNumero(producto.stock);
    if (stock === null) e.stock = 'Solo se pueden escribir números en esta casilla';
    else if (!esPorPeso(producto) && !Number.isInteger(stock)) e.stock = 'La cantidad tiene que ser un número entero (ej. 3, no 3.5). Si lo vendes por libra, cambia "Se vende" a Por libra.';
    else if (stock < 0) e.stock = 'El stock no puede ser negativo';
    else if (stock > 100000) e.stock = 'Esa cantidad parece un error (máximo 100,000)';
  }

  // --- Precios: números válidos, no negativos, con tope ---
  const costo = validarMonto(producto.precio_costo);
  if (costo.error) e.precio_costo = costo.error;
  const venta = validarMonto(producto.precio_venta);
  if (venta.error) e.precio_venta = venta.error;

  if (!e.precio_costo && !e.precio_venta && costo.valor !== null && venta.valor !== null && venta.valor < costo.valor)
    e.precio_venta = 'El precio de venta no puede ser menor al costo';

  return e;
}

// Revisa un monto en lempiras escrito a mano. { valor, error }
function validarMonto(texto) {
  if (texto === '' || texto === null || texto === undefined) return { valor: null, error: null };
  const n = aNumero(texto);
  if (n === null) return { valor: null, error: 'Solo se pueden escribir números en esta casilla' };
  if (n < 0) return { valor: n, error: 'No puede ser negativo' };
  if (n > MONTO_MAXIMO) return { valor: n, error: 'Ese monto es demasiado grande' };
  return { valor: n, error: null };
}

// Convierte los campos de texto del formulario a los tipos de la BD.
// Último filtro antes de guardar: nada que no sea un número llega a la base.
export function normalizarProducto(producto) {
  const num = (v, { entero = false } = {}) => {
    const n = aNumero(v);
    if (n === null || n < 0) return 0;
    return entero ? Math.trunc(n) : Math.round(n * 100) / 100;
  };
  return {
    nombre: limpiarTexto(producto.nombre, 120).trim(),
    marca: limpiarTexto(producto.marca, 60).trim(),
    talla: limpiarTexto(producto.talla, 30).trim(),
    color: limpiarTexto(producto.color, 40).trim(),
    categoria: producto.categoria,
    subtipo: producto.subtipo ? limpiarTexto(producto.subtipo, 60).trim() : null,
    descripcion: producto.descripcion ? limpiarTexto(producto.descripcion, 1000) : null,
    unidad: UNIDADES.some((u) => u.clave === producto.unidad) ? producto.unidad : 'unidad',
    stock: esPorPeso(producto) ? redondearCantidad(num(producto.stock)) : num(producto.stock, { entero: true }),
    precio_costo: num(producto.precio_costo),
    precio_venta: num(producto.precio_venta),
    impuesto: ['g15', 'g18', 'exento'].includes(producto.impuesto) ? producto.impuesto : 'g15',
    activo: producto.activo !== false, // "Mostrar en el catálogo"
  };
}
